<template>
    <a-row justify="left">
        <a-col :span="2"></a-col>
        <a-col :span="22">
            <div class="news">
                <template v-for="item in news">
                    <div class="item" @click="navigatorDetails(item.id)">
                        <p>{{item.day}}</p>
                        <p>{{item.time}}</p>
                        <div class="text">
                            {{ item.title }}
                        </div>
                        <hr />
                        <img :src="apiUrl+'/images/'+item.url" >
                        <div class="btn">
                            <ArrowRightOutlined />
                        </div>
                    </div>
                </template>
            </div>
        </a-col>
    </a-row>
</template>

<script setup lang="ts">
import {apiUrl} from '@/assets/js/global'
import {ArrowRightOutlined} from '@ant-design/icons-vue'
import rooter from '@/router'
const props = defineProps({
    news:<any> {
        type: Array,
        default: () => []
    }
})
const navigatorDetails = (id:any) => {
    rooter.push({
        path: '/newsDetails',
        query: {
            id: id
        } 
    })
}
</script>

<style lang="less" scoped>
.news {
    width: 100%;
    height: 660px;
    padding-bottom: 40px;
    overflow-x: auto;
    white-space: nowrap;
    overflow-y: hidden;

    .item {
        position: relative;
        display: inline-block;
        width: 484px;
        background: #F7F7F7;
        margin-right: 40px;
        height: 620px;
        padding: 47px 32px;

        p:nth-of-type(1) {
            font-size: 48px;
            color: #868686;
            margin: 0;
        }

        p:nth-of-type(2) {
            font-size: 16px;
            color: #868686;
            margin: 11px 0 40px 0;
        }

        .text {
            height: 56px;
            white-space: break-spaces;
            font-size: 24px;
            line-height: 28px;
            width: 420px;
            color: #868686;
            display: -webkit-box;
            /* 将元素设置为弹性盒子 */
            -webkit-box-orient: vertical;
            /* 设置弹性盒子的方向为垂直 */
            -webkit-line-clamp: 2;
            /* 限制显示的行数 */
            overflow: hidden;
            /* 隐藏超出部分 */
            text-overflow: ellipsis;
            /* 超出部分显示省略号 */
        }

        hr {
            margin-top: 40px;
            margin-bottom: 40px;
            border: none;
            border-top: 2px solid #dbdada;
        }

        img {
            width: 420px;
            height: 236px;
            object-fit:cover;
        }

        .btn{
            
            position: absolute;
            right: 72px;
            bottom: 86px;
            font-size: 24px;
            background-color: #fff;
            border-radius: 50%;
            width: 56px;
            height: 56px;
            text-align: center;
            line-height: 56px;
            color: #EA2709;
            display: none;
        }
    }

    .item:hover {
        background: rgba(234, 39, 9, 0.05);
        cursor:pointer;
        p:nth-of-type(1) {
            color: #EA2709;
        }
        .btn{
            display: block;
        }
    }
}
/* 自定义整个滚动条 */
::-webkit-scrollbar {
    height: 8px; /* 滚动条的宽度 */
}
 
/* 滚动槽 */
::-webkit-scrollbar-track {
    background: #F7F7F7; /* 滚动槽的颜色 */
}
 
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
    background: #dfdfdf; /* 滑块的颜色 */
    border-radius: 10px; /* 滑块的圆角 */
}
 
/* 滑块在鼠标悬停时的颜色 */
::-webkit-scrollbar-thumb:hover {
    background: #a7a7a7;
}
</style>